export const SET_HRES37U_INDEX_DISP = 'SET_HRES37U_INDEX_DISP'
export const GET_HRES37U_INDEX_DISP = 'GET_HRES37U_INDEX_DISP'
export const SET_HRES37U_DETAIL_DISP = 'SET_HRES37U_DETAIL_DISP'
export const GET_HRES37U_DETAIL_DISP = 'GET_HRES37U_DETAIL_DISP'
export const SET_HRES37U_MAX_ROWSPAN = 'SET_HRES37U_MAX_ROWSPAN'
export const GET_HRES37U_MAX_ROWSPAN = 'GET_HRES37U_MAX_ROWSPAN'
export const SET_HRES37U_COLUMNS = 'SET_HRES37U_COLUMNS'
export const GET_HRES37U_COLUMNS = 'GET_HRES37U_COLUMNS'
export const SET_HRES37U_LABELS = 'SET_HRES37U_LABELS'
export const GET_HRES37U_LABELS = 'GET_HRES37U_LABELS'
export const RECEIVED_HRES37U_COLUMNS_LABELS = 'RECEIVED_HRES37U_COLUMNS_LABELS'
export const SET_HRES37U_INDEX = 'SET_HRES37U_INDEX'
export const GET_HRES37U_INDEX = 'GET_HRES37U_INDEX'
export const RECEIVED_HRES37U_INDEX = 'RECEIVED_HRES37U_INDEX'
export const SET_HRES37U_INDEX_SELECTED = 'SET_HRES37U_INDEX_SELECTED'
export const GET_HRES37U_INDEX_SELECTED = 'GET_HRES37U_INDEX_SELECTED'
export const SET_HRES37U_DETAIL = 'SET_HRES37U_DETAIL'
export const GET_HRES37U_DETAIL = 'GET_HRES37U_DETAIL'
export const RECEIVED_HRES37U_DETAIL = 'RECEIVED_HRES37U_DETAIL'
export const TOGGLE_HRES37U_PAGE = 'TOGGLE_HRES37U_PAGE'
export const POST_HRES37U_SEND_APPROVE = 'POST_HRES37U_SEND_APPROVE'



// WEBPACK FOOTER //
// ./src/store/modules/hres37u/mutation-types.js